/* Copyright (C) nexleader - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written for nexleader <myipsat.com>, 2016-2018
 */

/*global angular*/
import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-nexleader-session-table-help-modal',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './session-table-help-modal.component.html',
})
export class NexleaderSessionTableHelpModalComponent {
  constructor(private bsModalService: BsModalService) { }

  close() {
    this.bsModalService.hide();
  }
}
